import React, { Component } from "react";
import DefaultHeader from "../CommonUtils/DefaultHeader";
import InitialFormHeader from "./InitialFormHeader";
import InitialFormContainer from "./InitialFormContainer";
import './InitialFormStyleSheet.css';
class InitialForm extends Component {
 
    render() {
        return (
            <div className="s360-initial-form" >
                {/* <DefaultHeader        {...this.props} /> */}
                {/* <InitialFormHeader    {...this.props} /> */}
                <InitialFormContainer {...this.props} />
            </div>
        );
    }
}

export default InitialForm;
